// 定义变量名，尽量复杂
const listName = '__SearchHistoryRecords__';
const maxCount = 15;
let isSupportLocalStorage = false;

try {
  const testKey = '__test__';
  window.localStorage.setItem(testKey, 'yes');
  if (window.localStorage.getItem(testKey) === 'yes') {
    isSupportLocalStorage = true;
    window.localStorage.removeItem(testKey);
  }
} catch (error) {
  console.log(error);
}

// 存搜索内容到本地list
export function saveToHistoryList(searchVal) {
  // 判断当前浏览器是否支持localStroge
  if (isSupportLocalStorage) {
    let oldItems = [];
    // 获取本地list
    const localList = window.localStorage.getItem(listName);
    if (localList) {
      oldItems = JSON.parse(localList);
    }
    // 格式化数据对象
    let newVal = String(searchVal).replace(/(^\s*)|(\s*$)/g, ''); // 去掉左右两端空格
    let newItem = { name: newVal };
    let newItems = [newItem];

    // 判断本地list是否包含当前插入对象，不包含才可存储
    oldItems.map(item => {
      if (item && item.name !== newVal && newItems.length < maxCount) {
        newItems.unshift(item);
      }
    });

    window.localStorage.setItem(listName, JSON.stringify(newItems.reverse()));
  }
}
// 读取本地list结果
export function searchHistoryList() {
  var items = [];
  if (isSupportLocalStorage) {
    let localList = window.localStorage.getItem(listName);
    if (localList) {
      items = JSON.parse(localList);
    }
  }
  return items;
}
// 清空本地list
export function clearHistoryList() {
  if (isSupportLocalStorage) {
    window.localStorage.setItem(listName, []);
    // window.localStorage.clear();
  }
}

// 使用
// import { saveToHistoryList, searchHistoryList, clearHistoryList } from '@/util/searchHistory';
// saveToHistoryList('iphone');
// let list = searchHistoryList();
// if (list) {
//   clearHistoryList();
// }
